// Tách/Gộp giá vật tư cho SP có cờ price_includes_material.
//
// Mô hình: đơn giá SP master (product.unit_price) đã GỒM giá vật tư M
// (material_price_per_unit). Mỗi dòng đơn có cờ tách/gộp:
//   - GỘP (split=false, mặc định): đơn giá SP = master; giá vật tư inline = 0
//     (giá vật tư nằm trong giá SP) → CK ăn cả chè + hộp.
//   - TÁCH (split=true): đơn giá SP = master − M; giá vật tư inline = giá cấu hình
//     → CK chỉ ăn chè, hộp giữ giá đúng.
//
// Toggle RESET từ master (không cộng/trừ trên giá hiện tại) để tránh sai khi user
// sửa giá tay sau khi tách rồi bấm gộp. Giá vật tư KHÔNG lưu-thành-0 khi gộp —
// packagingItems luôn giữ giá cấu hình; giá hiệu lực là hàm thuần của (giá, cờ).

/** Trạng thái tách/gộp của 1 dòng SP. */
export interface LineSplitState {
    /** SP có cờ price_includes_material. */
    priceIncludesMaterial: boolean
    /** Dòng đã tách giá vật tư. */
    materialPriceSplit: boolean
}

function round2(n: number): number {
    return Math.round(n * 100) / 100
}

/**
 * Vật tư của dòng đang GỘP (giá nằm trong giá SP) → giá hiển thị/tính = 0.
 * Chỉ đúng khi SP bật cờ; SP thường (cờ off) giá vật tư luôn là giá cấu hình.
 */
export function isMaterialMerged(line: LineSplitState): boolean {
    return line.priceIncludesMaterial && !line.materialPriceSplit
}

/**
 * Giá vật tư hiệu lực của 1 dòng vật tư theo trạng thái dòng SP: 0 khi gộp,
 * giá cấu hình khi tách (hoặc SP không bật cờ).
 */
export function effectiveMaterialUnitPrice(
    configuredPrice: number,
    line: LineSplitState,
): number {
    return isMaterialMerged(line) ? 0 : configuredPrice
}

/**
 * Đơn giá SP theo trạng thái, reset từ master: gộp = master; tách = master − M
 * (làm tròn 2 chữ số). Bỏ qua giá user sửa tay (chủ ý — ưu tiên giá đúng).
 */
export function productUnitPriceFor(
    masterUnitPrice: number,
    materialPricePerUnit: number,
    split: boolean,
): number {
    return split
        ? round2(masterUnitPrice - materialPricePerUnit)
        : masterUnitPrice
}

/**
 * Có cho phép TÁCH không: cần vật tư có giá (M>0) và giá tách không âm
 * (master ≥ M — nếu cấu hình sai khiến âm thì khoá tách).
 */
export function canSplitMaterial(
    masterUnitPrice: number,
    materialPricePerUnit: number,
): boolean {
    return (
        materialPricePerUnit > 0 && masterUnitPrice - materialPricePerUnit >= 0
    )
}

/**
 * Hiển thị nút tách/gộp? Chỉ khi SP bật cờ và có vật tư giá (M>0). Giá âm vẫn
 * hiện nút nhưng nút tách bị khoá (canSplitMaterial=false) + hint.
 */
export function showSplitToggle(
    priceIncludesMaterial: boolean | undefined,
    materialPricePerUnit: number | undefined,
): boolean {
    return !!priceIncludesMaterial && (materialPricePerUnit ?? 0) > 0
}
